const translations = {
  generateTemplate: 'Gerar template de importação',
  exportOf: 'Exportação de {{name}}',
  generate: 'Gerar',
  all: 'Todas',
  customize: 'Customizar',
  exportPdf: 'Exportar PDF',
  exportExcel: 'Exportar Excel',
  columns: 'Colunas',
  pdfInfo:
    'No formato PDF, será enviado por e-mail um resumo de cada atividade, já pronto para visualização e impressão.',
  creationDate: 'Data de criação',
  schedulingDate: 'Data de agendamento',
  period: 'Periodo',
  includeReplies: 'Incluir respostas',
  includeRepliesTooltip: 'Ao marcar esta opção, todas as colunas da atividade serão incluídas.',
  checklist: 'Questionário',
  formatBlockQuestions: 'Formatar perguntas de bloco',
  formatBlockQuestionsTooltip:
    'Cada linha da resposta será uma linha do arquivo exportado \n com os demais valores repetidos.',
  type: 'Tipo',
  name: 'Nome',
  email: 'Email',
  levels: 'Níveis',
  place: 'Local',
  number: 'Número',
  placeOrPerson: 'Local/Pessoa',
  userField: 'Usuário',
  startDate: 'Data inicial',
  endDate: 'Data final',
  replies: 'Respostas',
  exportingSelected: 'Exportando {{count}} atividade selecionada',
  exportingSelected_plural: 'Exportando {{count}} atividades selecionadas',
  exportHistory: 'Histórico de Exportação',
  of: 'de',
  date: 'Data',
  entity: 'Entidade',
  user: 'Usuário',
  download: 'Download',
  error: 'Erro'
}

export default translations
